/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Dashboard_Task_CaseInputs */

const en_dashboard_task_case = /** @type {(inputs: Dashboard_Task_CaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Case: ${i?.id}`)
};

const pt_br2_dashboard_task_case = /** @type {(inputs: Dashboard_Task_CaseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caso: ${i?.id}`)
};

/**
* | output |
* | --- |
* | "Case: {id}" |
*
* @param {Dashboard_Task_CaseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_task_case = /** @type {((inputs: Dashboard_Task_CaseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Task_CaseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_task_case(inputs)
	return pt_br2_dashboard_task_case(inputs)
});